import { RefundRequestSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * Refund requests against wash payments (G8).
 *
 *   tenants/{tid}/refundRequests/{refundId}
 *
 * READ-ONLY from the client. `infra/firestore.rules` denies every client write
 * here, because the rule that protects money — never refund more than the
 * customer paid — needs the archived ticket AND the sum of every other refund
 * against it, and rules cannot aggregate a query. Writes go through the
 * `requestRefund` / `decideRefund` callables.
 *
 * Tenant-level rather than per-outlet so an owner sees one list across every
 * outlet; `outletId` is a field on each record.
 */
export function refundsRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/refundRequests`,
    schema: RefundRequestSchema,
    name: `tenants/${tenantId}/refundRequests`,
  });
}
